export default function setLocation(places) {
  const change = places.replace(/,/g, '\n');

  const result = `El siguiente reporte se hizo mediante el análisis de los datos con la plataforma ewisemaps, a continuación los sitios que fueron analizados: \n \n ${change}`;

  return result;
}
